/* ROYAL HONEY FRANCE — theme scripts */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (cents) => {
    const v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  };

  /* ---------- Header ---------- */
  const header = $('.site-header');
  const onScroll = () => {
    if (header) header.classList.toggle('scrolled', window.scrollY > 24);
    const cta = $('.sticky-cta');
    if (cta) cta.classList.toggle('visible', window.scrollY > 600);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile menu ---------- */
  const menu = $('.mobile-menu');
  $$('[data-menu-toggle]').forEach((b) =>
    b.addEventListener('click', () => menu && menu.classList.toggle('open'))
  );
  if (menu) $('.backdrop', menu).addEventListener('click', () => menu.classList.remove('open'));

  /* ---------- Cart drawer ---------- */
  const drawer = $('#cart-drawer');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  };
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closePopup(); } });

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    $$('[data-cart-total]').forEach((el) => (el.textContent = money(cart.total_price)));
    const body = $('[data-cart-items]');
    const foot = $('[data-cart-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="empty-cart"><p class="muted">Votre panier est vide.</p>' +
        '<button class="btn liquid-gold-btn" data-cart-close>Continuer mes achats</button></div>';
      if (foot) foot.classList.add('hidden');
      $$('[data-cart-close]', body).forEach((b) => b.addEventListener('click', closeDrawer));
      return;
    }
    if (foot) foot.classList.remove('hidden');

    body.innerHTML = cart.items
      .map(
        (item, i) => `
      <div class="line-item glass">
        <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/, '_200x$1$2') : ''}" alt="${item.product_title}" loading="lazy">
        <div class="li-body">
          <a href="${item.url}" class="li-name">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="label-mono muted" style="margin-top:4px">${item.variant_title}</div>` : ''}
          <div class="li-actions">
            <div class="qty glass">
              <button type="button" data-line-change="${i + 1}" data-qty="${item.quantity - 1}" aria-label="Diminuer">−</button>
              <span style="font-family:var(--font-mono);width:28px;text-align:center">${item.quantity}</span>
              <button type="button" data-line-change="${i + 1}" data-qty="${item.quantity + 1}" aria-label="Augmenter">+</button>
            </div>
            <span class="gold-text" style="font-family:var(--font-heading);font-weight:700">${money(item.final_line_price)}</span>
          </div>
        </div>
      </div>`
      )
      .join('');

    $$('[data-line-change]', body).forEach((btn) =>
      btn.addEventListener('click', () =>
        changeLine(parseInt(btn.dataset.lineChange, 10), parseInt(btn.dataset.qty, 10))
      )
    );
  }

  function fetchCart() {
    return fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then((r) => r.json())
      .then((cart) => { renderCart(cart); return cart; });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) }),
    })
      .then((r) => r.json())
      .then(renderCart);
  }

  window.RHFAddToCart = function (id, quantity, button) {
    if (button) { button.dataset.label = button.innerHTML; button.innerHTML = 'Ajout…'; button.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status && res.status !== 200) throw new Error(res.description || 'Erreur');
        return fetchCart();
      })
      .then(() => openDrawer())
      .catch((err) => alert(err.message || "Impossible d'ajouter ce produit."))
      .finally(() => {
        if (button) { button.innerHTML = button.dataset.label; button.disabled = false; }
      });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('form');
    const id = btn.dataset.variantId || (form && form.querySelector('[name="id"]')?.value);
    const qtyInput = form && form.querySelector('[name="quantity"]');
    if (!id) return;
    window.RHFAddToCart(id, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1, btn);
  });

  if (drawer) fetchCart();

  /* ---------- Quantity steppers (product form) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const step = parseInt(b.dataset.qtyStep, 10);
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product total ---------- */
  const totalEl = $('[data-line-total]');
  if (totalEl) {
    const update = () => {
      const price = parseInt(totalEl.dataset.unitPrice, 10);
      const qty = parseInt($('[name="quantity"]')?.value, 10) || 1;
      totalEl.textContent = money(price * qty);
    };
    $$('[name="quantity"]').forEach((i) => i.addEventListener('change', update));
    document.addEventListener('variant:change', update);
  }

  /* ---------- Variant selector ---------- */
  $$('[data-variant-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const opt = sel.options[sel.selectedIndex];
      const form = sel.closest('form');
      if (form) form.querySelector('[name="id"]').value = opt.value;
      const priceEl = $('[data-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = money(parseInt(opt.dataset.price, 10));
      const total = $('[data-line-total]');
      if (total && opt.dataset.price) total.dataset.unitPrice = opt.dataset.price;
      document.dispatchEvent(new Event('variant:change'));
    });
  });

  /* ---------- Product gallery ---------- */
  $$('[data-thumb]').forEach((t) =>
    t.addEventListener('click', () => {
      const main = $('[data-main-image]');
      if (main) main.src = t.dataset.thumb;
      $$('[data-thumb]').forEach((x) => x.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
    })
  );

  /* ---------- 3D tilt ---------- */
  $$('[data-tilt]').forEach((el) => {
    el.addEventListener('mousemove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `perspective(1000px) rotateY(${x * 14}deg) rotateX(${-y * 12}deg)`;
    });
    el.addEventListener('mouseleave', () => {
      el.style.transform = 'perspective(1000px) rotateY(0deg) rotateX(0deg)';
    });
  });

  /* ---------- Hero showcase carousel ---------- */
  $$('[data-showcase]').forEach((box) => {
    const slides = $$('.showcase-slide', box);
    const dots = $$('.showcase-dots button', box);
    if (slides.length < 1) return;
    let index = 0, timer = null;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('active', n === index));
      dots.forEach((d, n) => d.classList.toggle('active', n === index));
    };
    const start = () => { if (slides.length > 1) timer = setInterval(() => go(index + 1), 4500); };
    const stop = () => clearInterval(timer);
    dots.forEach((d, n) => d.addEventListener('click', () => { stop(); go(n); start(); }));
    $$('[data-showcase-prev]', box).forEach((b) => b.addEventListener('click', () => { stop(); go(index - 1); start(); }));
    $$('[data-showcase-next]', box).forEach((b) => b.addEventListener('click', () => { stop(); go(index + 1); start(); }));
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    go(0); start();
  });

  /* ---------- Ingredient orbs ---------- */
  $$('[data-orbs]').forEach((box) => {
    const orbs = $$('.orb', box);
    const out = $('[data-orb-desc]', box);
    orbs.forEach((orb) =>
      orb.addEventListener('click', () => {
        orbs.forEach((o) => o.setAttribute('aria-selected', 'false'));
        orb.setAttribute('aria-selected', 'true');
        if (out) out.innerHTML =
          '<span class="gold-text" style="font-family:var(--font-heading);font-weight:600">' +
          orb.dataset.label + ' — </span>' + orb.dataset.desc;
      })
    );
  });

 /* ---------- Discount popup ---------- */
const popup = $('#discount-popup');

function closePopup(markCodeUsed) {
  if (!popup) return;
  popup.classList.remove('open');
  try {
    localStorage.setItem('rhf_popup_seen', '1');
    if (markCodeUsed) localStorage.setItem('rhf_popup_code_used', '1');
  } catch (e) {}
}

if (popup) {
  let seen = false;
  let codeUsed = false;
  try {
    seen = localStorage.getItem('rhf_popup_seen') === '1';
    codeUsed = localStorage.getItem('rhf_popup_code_used') === '1';
  } catch (e) {}

  const atCheckout = window.location.pathname.includes('/checkout');
  const shouldShow = !window.Shopify?.designMode && (!seen || (atCheckout && !codeUsed));

  if (shouldShow) {
    setTimeout(() => popup.classList.add('open'), parseInt(popup.dataset.delay, 10) || 3500);
  }

  // Clic sur l'overlay → fermer sans marquer le code
  popup.addEventListener('click', (e) => { if (e.target === popup) closePopup(false); });

  // Croix → fermer, ne réapparaît plus
  $('[data-popup-close]:not(a)', popup) && 
    $$('[data-popup-close]', popup)
      .filter(b => b.tagName !== 'A')
      .forEach(b => b.addEventListener('click', () => closePopup(false)));

  // Bouton "J'en profite" → marquer code utilisé
  const ctaLink = $('a[data-popup-close]', popup);
  if (ctaLink) ctaLink.addEventListener('click', () => closePopup(true));

  // Copier le code
  const copyBtn = $('[data-copy-code]', popup);
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const code = copyBtn.dataset.copyCode;
      navigator.clipboard?.writeText(code);
      const label = $('.copy-state', copyBtn);
      if (label) { label.textContent = 'Copié'; setTimeout(() => (label.textContent = 'Copier'), 2000); }
    });
  }
}




  /* ---------- WhatsApp tooltip ---------- */
  const wa = $('.wa-float');
  if (wa) {
    let dismissed = false;
    try { dismissed = localStorage.getItem('rhf_wa_tooltip_dismissed'); } catch (e) {}
    if (!dismissed) setTimeout(() => $('.wa-tip', wa)?.classList.add('show'), 4000);
    $('[data-wa-dismiss]', wa)?.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      try { localStorage.setItem('rhf_wa_tooltip_dismissed', '1'); } catch (err) {}
      $('.wa-tip', wa)?.classList.remove('show');
    });
  }
})();
